export const systemAdmin = {
  title: 'Rendszergazda',
  subtitle: 'Rendszerszintű beállítások és felügyeleti funkciók',
  box: {
    users: {
      title: "Felhasználók kezelése",
      description: "Felhasználói fiókok, engedélyek és szerepkörök kezelése",
      link: "Felhasználók kezelése"
    },
    organizations: {
      title: "Szervezetek kezelése",
      description: "Szervezetek, felhasználói fiókok, engedélyek és szerepkörök kezelése",
      link: "Szervezetek kezelése"
    },
    workpages: {
      title: "Munkalapok kezelése",
      description: "Munkalapok, felhasználói fiókok, engedélyek és szerepkörök kezelése",
      link: "Munkalapok kezelése"
    },
    workPageTemplates: {
      title: "Munkalap sablonok kezelése",
      description: "Munkalap sablonok, felhasználói fiókok, engedélyek és szerepkörök kezelése",
      link: "Munkalap sablonok kezelése"
    },
  },
  messages: {
    user: {
      failedToLoad: 'Sikertelen a felhasználók betöltése',
      createdSuccess: 'Felhasználó sikeresen létrehozva',
      createdError: 'Sikertelen a felhasználó létrehozása',
      updatedSuccess: 'Felhasználó sikeresen frissítve',
      updatedError: 'Sikertelen a felhasználó frissítése',
      deletedSuccess: 'Felhasználó sikeresen törölve',
      deletedError: 'Sikertelen a felhasználó törlése',
      confirmTitle: 'Felhasználó törlése',
      deleteQuestion: 'Biztosan törölni szeretné ezt a felhasználót?',
      deleteWarning: 'Ez a művelet nem visszavonható.'
    }
  },
  users: {
    title: 'Felhasználók',
    addUser: 'Felhasználó hozzáadása',
    deleteUser: 'Felhasználó törlése',
    noName: 'Névtelen',
    never: 'Soha',
    editUser: 'Felhasználó szerkesztése',
    fields: {
      name: 'Név',
      email: 'Email',
      role: 'Szerepkör',
      created: 'Létrehozva',
      lastLogin: 'Utolsó bejelentkezés',
      user: 'Felhasználó',
      actions: 'Műveletek'
    },
    roles: {
      super_admin: 'Szuper admin',
      admin: 'Admin',
      user: 'Felhasználó'
    },
    placeholders: {
      name: 'Név',
      email: 'Email',
      role: 'Szerepkör',
    },
  }
}
